<template lang="pug">
  .card
    header.modal-card-head.display-flex
      p.flex-1
        span(v-if="id") Editar delegacion ID - {{ id }}
        span(v-else) Crear delegacion
      span.icon.close(
          @click="$emit('close')"
        )
          i.fa.fa-close
    .card-content
      .contenedor-datos
        .fechas
          .control
            label Desde
            input.input(type="date", v-model="fechaInicio")
          .control
            label Hasta
            input.input(type="date", v-model="fechaFin")
        .codigo-empleado(v-if="!isCreatingSelf")
          label Empleado
          .input-container
            input.input(
              type="number",
              v-model="codigoEmpleadoOrigen",
              @click="mostrarBusquedaEmpleadoOrigen = true"
              :disabled="id!=0"
            )
            .erase-data(@click="codigoEmpleadoOrigen = ''", v-if="!id")
              .icon
                .fa.fa-times
            transition(name="fade-quick")
              .pop-over(
                  v-if="mostrarBusquedaEmpleadoOrigen"
                )
                  lookup-small-empleado(
                    @selected="seleccionarEmpleadoOrigen"
                    @close="mostrarBusquedaEmpleadoOrigen = false"
                    :codigo="codigoEmpleadoOrigen"
                  )
        .codigo-empleado.pt-10
          label Reemplazante
          .input-container
            input.input(
              type="number",
              v-model="codigoEmpleadoReemplazante",
              @click="mostrarBusquedaEmpleadoReemplazante = true"
            )
            .erase-data(@click="codigoEmpleadoReemplazante = ''")
              .icon
                .fa.fa-times
            transition(name="fade-quick")
              .pop-over(
                  v-if="mostrarBusquedaEmpleadoReemplazante"
                )
                  lookup-small-empleado(
                    @selected="seleccionarEmpleadoReemplazante"
                    @close="mostrarBusquedaEmpleadoReemplazante = false"
                    :codigo="codigoEmpleadoReemplazante"
                  )
    footer.card-footer
      a.card-footer-item.is-success(@click="guardar")
        span(v-if="isSaving") Guardando...
        span(v-else) Guardar
      a.card-footer-item( @click="$emit('close')")
        strong Cancelar

</template>

<script>
import { apiPost, notify } from '../util/general'
import LookupSmallEmpleado from './Component_Lookup_Small_Empleado.vue'
import moment from 'moment'

export default {
  name: 'delegaciones-rrhh-guardar',
  components: {
    'lookup-small-empleado': LookupSmallEmpleado
  },
  props: {
    info: {
      type: Object,
      required: false
    },
    isCreatingSelf: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      id                                  : 0,
      fechaInicio                         : moment().format('YYYY-MM-DD'),
      fechaFin                            : moment().format('YYYY-MM-DD'),
      codigoEmpleadoOrigen                : 0,
      codigoEmpleadoReemplazante          : 0,
      activo                              : true,
      mostrarBusquedaEmpleadoOrigen       : false,
      mostrarBusquedaEmpleadoReemplazante : false,
      isSaving                            : false,
      isLoading                           : false,
      codigoEmpleado                      : localStorage.getItem('codigo'),
      perfil                              : localStorage.getItem('perfilVacaciones')
    }
  },
  mounted () {
    if (Object.keys(this.info).length) {
      this.isLoading = true
      let data = [
        'id',
        'fechaInicio',
        'fechaFin',
        'codigoEmpleadoOrigen',
        'codigoEmpleadoReemplazante',
        'activo'
      ]
      data.forEach((d) => {
        this[d] = this.info[d]
      })
      this.isLoading = false
    }
  },
  methods: {
    guardar () {
      var vm = this
      if (vm.isSaving) return;
      vm.isSaving = true
      var obj = {
        fechaInicio                 : vm.fechaInicio,
        fechaFin                    : vm.fechaFin,
        codigoEmpleadoOrigen        : vm.codigoEmpleadoOrigen,
        codigoEmpleadoReemplazante  : vm.codigoEmpleadoReemplazante,
        activo                      : 1
      }
      if (vm.id) {
        obj.id        = vm.id
      }
      if (vm.isCreatingSelf) {
        obj.codigoEmpleadoOrigen = vm.codigoEmpleado
      }
      apiPost(vm, '/delegaciones', obj, function (data) {
        if (vm.activo) {
          if (data.estoyReemplazando) {
            vm.$store.dispatch('setEstoyReemplazando', true)
            vm.$store.dispatch('setNombreReemplazo', data.nombreReemplazo)
          } else if (data.estoySiendoReemplazado) {
            vm.$store.dispatch('setEstoySiendoReemplazado', true)
            vm.$store.dispatch('setNombreReemplazo', data.nombreReemplazo)
          }
        } else if ((data.estoyReemplazando || data.estoySiendoReemplazado) && !vm.activo) {
          vm.$store.dispatch('setEstoyReemplazando', false)
          vm.$store.dispatch('setEstoySiendoReemplazado', false)
          vm.$store.dispatch('setNombreReemplazo', '')
        }
        notify(vm, 'success', 'Éxito', 'Guardado correctamente')
        if (vm.id && vm.perfil === 'recursos humanos' && (+vm.codigoEmpleadoOrigen === +vm.codigoEmpleado || +vm.codigoEmpleadoReemplazante === +vm.codigoEmpleado || +vm.info.codigoEmpleadoOrigen === +vm.codigoEmpleado || +vm.info.codigoEmpleadoReemplazante === +vm.codigoEmpleado)) {
          window.location.reload()
          return
        }

        if (!vm.id && vm.perfil === 'recursos humanos' && (+vm.codigoEmpleadoOrigen === +vm.codigoEmpleado || +vm.codigoEmpleadoReemplazante === +vm.codigoEmpleado)) {
          window.location.reload()
          return
        }

        if (vm.isCreatingSelf) {
          window.location.reload()
        }
        vm.$emit('closeRefresh')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
      })
    },
    seleccionarEmpleadoOrigen (o) {
      this.codigoEmpleadoOrigen = o.codigo
    },
    seleccionarEmpleadoReemplazante (o) {
      this.codigoEmpleadoReemplazante = o.codigo
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>

  .close
    float right
    cursor pointer
    i
      font-size 16px

  .title
    font-size 16px
    span
      font-weight bold
      text-transform uppercase
    .little
      font-size 14px

  .contenedor-datos
    display flex
    justify-content center
    flex-direction column
    >*
      transition: all 0.5s;
    .fechas
      display flex
      justify-content center
      flex-direction: row
      .control
        padding 10px
    .activo
      display flex
      justify-content center
      flex-direction: row
      label
        padding-right 3px
  .codigo-empleado
    position relative
    padding-left 55px
    padding-right: 55px
    .control
      text-align center
      .input
        width 100px
    .input-container

      display flex
      align-items center
      .input
        flex 1
        width 100px
        position relative

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0


  .indicaciones
    flex 1
    padding 10px
    border 1px solid #209cee
    color: #12537e;
    background-color #f6fbfe
    display flex
    flex-direction column
    margin 10px
    max-width: 426px;

    strong
      color #209cee

    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 21px
      margin-bottom 5px

    .list
      display flex
      flex-direction column
      justify-content center
      flex 1
      text-align left
      .list-item
        padding-left 10px

  .codigo-empleado
    position relative
    .control
      text-align center
      .input
        width 100px

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    width: 300px;
    z-index: 70;
    top 0
    left: 42px;
</style>



// WEBPACK FOOTER //
// c_gestion_delegaciones_rrhh_guardar.vue?7158bc88